import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { useCallback } from 'react';

export const useLogin = () => {
  const { user, getAccessTokenSilently } = useAuth0();

  const getAccessToken = useCallback(async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      return accessToken;
    } catch (e) {
      console.error(e);
      return null;
    }
  }, [getAccessTokenSilently]);

  const getMe = useCallback(async () => {
    const accessToken = await getAccessToken();
    if (!accessToken) return null;
    const url = import.meta.env.VITE_AUTH0_PROFILE;

    const response = await axios.get(url + '', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  }, [getAccessToken]);

  return {
    getMe,
    name: user?.name || '',
    email: user?.email || '',
    getAccessToken,
  };
};
